import request from "@/utils/server.js";
// 登录模块

//获取用户信息授权登录
export function companyGetInfoAPI(data) {
  return request({
    url: "/getInfo",
    method: "get",
    data,
  });
}
// 获取验证码
export function getTheCode(params) {
  return request({
    url: "/app/getCode",
    method: "get",
    params,
  });
}
// 验证验证码
export function verifyCodeAPI(data) {
  return request({
    url: "app/LoginCode",
    // url: 'Card/LoginCode',
    method: "post",
    data,
  });
}
// 完善信息
export function editCardAPI(data) {
  return request({
    url: "Card/edit",
    // url: 'Card/LoginCode',
    method: "put",
    data,
  });
}

// 登录
export function login(data) {
  return request({
    url: "/wx/qr/base64",
    method: "get",
    data,
  });
}
// 登录
export function loginPassAPI(data) {
  return request({
    url: "/app/yLogin",
    method: "post",
    data,
  });
}
// getFirstClassify: '/classify/getFirstClassify',
